import React from 'react';
import Dialog from '@mui/material/Dialog';

import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/system';
import { Stack, Typography, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircle';
import { CloseOutlined } from '@mui/icons-material';
export default function RequestConfirmation({ open, setOpen, requestID }) {
    const matches = useMediaQuery((theme) => theme.breakpoints.up('sm'));

    //const dispatch = useDispatch();

    /*const handleChange = (prop) => (e) => {
        setPayload({ ...payload, [prop]: e.target.value });
    };
        const [payload, setPayload] = useState({
        courseName: "",
        courseCode: "",
        courseDesc: "",
        courseCreated: "",
    });
    const [alert, setAlert] = useState({
        message: "This is an alert message.",
        severity: "success",
    })

    */
    const handleClose = () => {
        setOpen(false);
    };


    const style = {
        button: {
            textTransform: "none"
        },
        toggleButton: {
            border: 0,
            padding: 0,
            borderRadius: "50%",
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
        textField: {
            minWidth: matches ? 400 : 300,
            '& label.Mui-focused': {
                color: (theme) => theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                fontStyle: "italic",
                borderRadius: 7,
                '&.Mui-focused fieldset': {
                    border: "3px black solid",
                },
            },
        },
        dialog: {
            minWidth: matches ? 700 : 200,
            maxWidth: 500,
            margin: "auto",
        }
    }


    return (
        <Box>
            <Dialog
                open={open}
                aria-labelledby="responsive-dialog-title"
                sx={style.dialog}
            >
                <DialogTitle id="responsive-dialog-title">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Box component="span" sx={{ flexGrow: 1 }} />
                        <IconButton onClick={handleClose}>
                            <CloseOutlined />
                        </IconButton>
                    </Stack>
                </DialogTitle>
                <Stack direction="column" alignItems="center" spacing={matches ? 4 : 1} sx={{ margin: 2 }}>
                    <CheckIcon sx={{ fontSize: 100, color: "#A0D842", }} />
                    <Typography variant="h6" sx={{ textAlign: "center" }}>
                        Your transaction code is: {requestID}
                    </Typography>
                    <Typography variant="body1" sx={{ textAlign: "center" }}>
                        Transaction Complete! Check your reservation status by
                        clicking your profile icon and then head over to My Books.
                        Frequently check your notifications for further
                        updates.
                    </Typography>
                    <Box sx={{ height: matches ? 20 : 10 }} />
                </Stack>
            </Dialog>
        </Box>
    );
}